import ExpansionPanelRoot, { Props } from './ExpansionPanel'

export default function ExpansionPanel(props: Props) {
  return <ExpansionPanelRoot {...props} />
}
